import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
import {async} from 'regenerator-runtime';
import insightIcon from '../PortalsBlock/images/icon-insight/icon-120-insight.svg';
import dwhSelfCareSuspendActivateAccount from './dwhReports';
import Popup from 'app/Components/Shared/PopUpWithAnimation/PopUpWithAnimation';
import {GetRentSuspensionReasons} from 'app/Components/Block/PortalsBlock/portalSlice';

const SelectActionPopup = (props) => {

  dwhSelfCareSuspendActivateAccount({
    actionType: 'Action Selection',
    status: 'Ongoing',
    messageText: 'Selecting an action on the subscription',
    ...props.params,
  });

  const openCancellationReasonPopUp = () =>{
    props.setShowCancellationReasonPopup(true);
    props.setShowActionPopup(false);
  }

  const getRentSuspensionReasons = async () => {
    if(props.suspensionReasons?.length === 0 || !props.suspensionReasons){ 
      await props.GetRentSuspensionReasons({orgId: props.selectedHetPay});
    }
  }

  const handleClick = async (action,reason) => {
    await props.onClickActionButton(action,reason);
  };

  return (
    <Container fluid>
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center'>
          <Image src={insightIcon} alt='התראה' />
        </Row>
        <Row className='justify-content-center'>
          <span className='title'>לפני שנמשיך</span>
        </Row>
        <Row className='justify-content-center'>
          <span className='content'>איזה פעולה תרצו לעשות על החשבון שבחרתם?</span>
        </Row>
      </div>
      <Row className='justify-content-center mt-2'>
        <button
          className='btn-submit-purple'
          onClick={async () => {
            openCancellationReasonPopUp();
            await getRentSuspensionReasons();
          }}>
          חסימת חשבון
        </button>
      </Row>
      <Row className='justify-content-center mt-2'>
        <button
          className='btn-submit-purple'
          onClick={() => {
            handleClick('activate','CR');
          }}>
          פתיחת חשבון
        </button>
      </Row>
      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    suspensionReasons: state.portalsBlock.suspensionReasons,
    selectedHetPay: state.portalsBlock.selectedHetPay,
  };
}

const mapDispatchToProps = {
  GetRentSuspensionReasons
};
export default connect(mapStateToProps, mapDispatchToProps)(SelectActionPopup);
